<template>
  <div id="journal-website-publish">
    <div class="ipub-h1 mar-b-30">Journal Website</div>
    <ipub-select style="width:220px"
                 class="mar-b-40"
                 v-model="currentJournal"
                 @change="onJournalChange"
                 placeholder="Select Journal">
      <ipub-select-option v-for="value in journals"
                          :key="value.id || value.name"
                          :value="value.id">
        {{value.name}}
      </ipub-select-option>
    </ipub-select>
    <template v-if="currentJournal">
      <site-tab class="mar-b-30"
                :menus="menus" />
      <router-view></router-view>
    </template>
    <ipub-empty v-else />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
